import React, { useEffect } from 'react'
import { useMediaQuery } from 'react-responsive'
import { useAppDispatch, useAppSelector } from '@nogin/widget2/src/redux'
import { setIsMobile } from '@nogin/widget2/src/redux/slices/app'

export default function GlobalScope({ children }: { children: any }) {
  const dispatch = useAppDispatch()
  const isMobileScreen = useMediaQuery({ query: '(max-width: 768px)' })
  const isMobile = useAppSelector((state) => state.app.isMobile)

  useEffect(() => {
    if (isMobileScreen !== isMobile) {
      dispatch(setIsMobile(isMobileScreen))
    }
  }, [isMobileScreen])
  return <>{children}</>
}
